<template>
  <div class="dashboard-nav-container" :class="{ minimized: !isExpanded }">
    <div
      class="dashboard-nav"
      :class="{ dark: isDarkMode, minimized: !isExpanded }"
      @mouseenter="() => (isExpanderVisible = true)"
      @mouseleave="
        () => {
          isExpanderVisible = false
        }
      "
    >
      <div class="nav-content" :class="{ minimized: !isExpanded }">
        <div>
          <a class="logo-container" href="/">
            <img
              class="logo"
              :class="{
                minimized: !isExpanded,
                long: !isAppClassic(),
                signals: isAppSignals(),
                cryptosignals: isAppCryptoSignals(),
              }"
              :src="logoSrc"
            />
          </a>
          <NumeraiTooltip class="nav-tooltip" text="Home" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/home"
              :class="{ active: activeTab === 'home', minimized: !isExpanded }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-home-outline</v-icon
              >
              <div
                class="badge-row flexrow full-width space_between"
                :class="{ minimized: !isExpanded }"
              >
                <div class="nav-link-text">
                  Home
                </div>
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip text="Leaderboard" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/tournament"
              :class="{
                active: activeTab === 'leaderboard',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-trophy-outline</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Leaderboard
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip text="Season" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/season"
              :class="{
                active: activeTab === 'season',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-gamepad-circle</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Season
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip
            v-if="isAppCryptoSignals()"
            text="Meta Model"
            :disable="isExpanded"
          >
            <router-link
              class="nav-link-container text_decoration_none"
              to="/meta-model"
              :class="{
                active: activeTab === 'meta-model',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-merge</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Meta Model
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip text="Data" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/data"
              :class="{ active: activeTab === 'data', minimized: !isExpanded }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-database</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Data
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip v-if="isLoggedIn" text="Models" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/models"
              :class="{
                active: activeTab === 'models',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-graph-outline</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Models
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip
            v-if="isLoggedIn"
            text="Submissions"
            :disable="isExpanded"
          >
            <router-link
              class="nav-link-container text_decoration_none"
              to="/submissions"
              title="Submissions"
              :class="{
                active: activeTab === 'submissions',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-calendar-month-outline</v-icon
              >
              <div
                class="badge-row flexrow full-width space_between"
                :class="{ minimized: !isExpanded }"
              >
                <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                  Submissions
                </div>
                <div v-if="isAppClassic() && hasPickleError">
                  <NumeraiTooltip
                    class="nav-tooltip"
                    text="There's an error with your model submissions"
                  >
                    <div class="nav-link-badge alert">
                      <strong>!</strong>
                    </div>
                  </NumeraiTooltip>
                </div>
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip v-if="isLoggedIn" text="Scores" :disable="isExpanded">
            <router-link
              class="nav-link-container text_decoration_none"
              to="/scores"
              :class="{
                active: activeTab === 'scores',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon"
                >mdi-chart-line</v-icon
              >
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Scores
              </div>
            </router-link>
          </NumeraiTooltip>
          <NumeraiTooltip
            v-if="isLoggedIn"
            text="Staking"
            :disable="isExpanded"
          >
            <router-link
              class="nav-link-container text_decoration_none"
              to="/staking"
              :class="{
                active: activeTab === 'staking',
                minimized: !isExpanded,
              }"
            >
              <v-icon v-if="!isExpanded" class="nav-link-icon">mdi-tune</v-icon>
              <div class="nav-link-text" :class="{ minimized: !isExpanded }">
                Staking
              </div>
            </router-link>
          </NumeraiTooltip>
        </div>
        <v-spacer></v-spacer>
        <div class="dark-mode-toggle-container">
          <a title="Toggle dark mode" @click="toggleDarkMode">
            <img
              class="dark-mode-toggle"
              :class="{ dark: isDarkMode }"
              :src="require('@/assets/darkmode.svg')"
            />
          </a>
        </div>
      </div>
      <div class="nav-border-container">
        <div class="nav-border" :class="{ dark: isDarkMode }"></div>
      </div>
      <div
        class="expander"
        :class="{
          dark: isDarkMode,
          visible: isExpanderVisible,
          hidden: !isExpanderVisible,
          minimized: !isExpanded,
        }"
        @click="toggleExpand"
      >
        <v-icon class="expander-icon" color="#434242">{{
          expanderIcon
        }}</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'
import { isAppClassic, isAppSignals, isAppCryptoSignals } from '@/lib/utils'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    minimize: { type: Boolean, default: false },
  },
  data: () => ({
    activeTab: '',
    isExpanderVisible: false,
    isExpanded: true,
  }),
  computed: {
    ...mapGetters(['isLoggedIn', 'isDashboardNavMinimized', 'isDarkMode']),
    ...mapState(['accountInfo', 'hasPickleError']),
    logoSrc() {
      if (!this.isExpanded) {
        return this.isDarkMode
          ? require('@/assets/Numerai-Sigil-White-Glitch8.gif')
          : require('@/assets/Numerai-Sigil-Black.png')
      } else if (isAppSignals()) {
        return this.isDarkMode
          ? require('@/assets/signals-logo-white.png')
          : require('@/assets/signals-logo-black.png')
      } else if (isAppCryptoSignals()) {
        return this.isDarkMode
          ? require('@/assets/cryptosignals-logo-white.png')
          : require('@/assets/cryptosignals-logo-black.png')
      } else {
        return this.isDarkMode
          ? require('@/assets/Numerai-Logo-Side-White.png')
          : require('@/assets/Numerai-Logo-Side-Black.png')
      }
    },
    expanderIcon() {
      return this.isExpanded
        ? 'mdi-chevron-double-left'
        : 'mdi-chevron-double-right'
    },
    darkModeIcon() {
      return this.isDarkMode ? 'mdi-weather-sunny' : 'mdi-moon-waning-crescent'
    },
  },
  watch: {
    async '$route.path'(newPath) {
      this.setTab(newPath)
    },
    minimize(newVal) {
      if (newVal) {
        this.isExpanded = false
        this.$store.dispatch('saveDashboardNavMinimized', true)
      }
    },
    accountInfo(newVal) {
      if (newVal && newVal.models && newVal.models != this.accountInfo.models) {
        this.fetchPickles()
      }
    },
  },
  async created() {
    const path = this.$router.currentRoute.path
    this.setTab(path)
    this.isExpanded = !this.isDashboardNavMinimized
    if (this.minimize) {
      this.isExpanded = false
      this.$store.dispatch('saveDashboardNavMinimized', true)
    }

    if (this.isLoggedIn) {
      this.fetchAccountInfo()
      this.fetchAllModelUploads()
    }
  },
  methods: {
    isAppClassic,
    isAppSignals,
    isAppCryptoSignals,
    ...mapActions(['fetchAccountInfo', 'fetchAllModelUploads']),
    setTab(path) {
      if (path === '/home') {
        this.activeTab = 'home'
      } else if (path.includes('/data/')) {
        this.activeTab = 'data'
      } else if (path === '/models') {
        this.activeTab = 'models'
      } else if (path === '/submissions') {
        this.activeTab = 'submissions'
      } else if (path === '/scores') {
        this.activeTab = 'scores'
      } else if (path === '/staking') {
        this.activeTab = 'staking'
      } else if (path === '/leaderboard') {
        this.activeTab = 'leaderboard'
      } else if (path === '/season') {
        this.activeTab = 'season'
      } else if (path === '/wallet') {
        this.activeTab = 'wallet'
      } else if (path === '/account') {
        this.activeTab = 'settings'
      } else if (path === '/meta-model') {
        this.activeTab = 'meta-model'
      } else {
        this.activeTab = ''
      }
    },
    async toggleDarkMode() {
      await this.$store.dispatch('saveDarkMode', this.isDarkMode ? false : true)
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      this.$store.dispatch('saveDashboardNavMinimized', !this.isExpanded)
    },
  },
}
</script>

<style scoped>
.dashboard-nav-container {
  position: relative;
  min-width: 240px;
}

.dashboard-nav-container.minimized {
  min-width: 60px;
}

.dashboard-nav {
  z-index: 10;
  position: fixed;
  height: 100vh;
  width: 240px;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background: var(--color-almost-white);
  transition: all 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
  border-right: 1px solid var(--color-very-subtle);
}

.dashboard-nav.dark {
  background: var(--paper-background-color);
}

.dashboard-nav-container.minimized,
.dashboard-nav.minimized {
  width: 60px;
}

.nav-content {
  padding: 25px 15px 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  overflow: hidden;
  transition: all 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
}

.nav-content.minimized {
  padding: 25px 10px 15px;
}

.logo-container {
  overflow: hidden;
}

.logo {
  height: 40px;
  padding-left: 10px;
  margin-bottom: 40px;
}

.logo.long {
  height: unset;
  width: 200px;
}

.logo.signals.minimized {
  filter: invert(77%) sepia(34%) saturate(4997%) hue-rotate(136deg)
    brightness(88%) contrast(92%);
  height: 40px;
  width: unset;
}

.logo.cryptosignals.minimized {
  filter: invert(76%) sepia(46%) saturate(6439%) hue-rotate(89deg)
    brightness(101%) contrast(83%);
  height: 40px;
  width: unset;
}

.logo.minimized {
  padding-left: 1px;
}

.nav-tooltip:hover {
  cursor: pointer;
}

.nav-link-container {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 7px 18px;
  border-radius: 2px;
  margin-bottom: 10px;
  overflow: hidden;
}

.theme--light.v-icon {
  color: var(--color-secondary);
}

.nav-link-container.active,
.nav-link-container.active .nav-link-text,
.nav-link-container.active .nav-link-icon,
.nav-link-container:hover {
  color: var(--color-primary);
  cursor: pointer;
}

.nav-link-container:hover {
  background-color: var(--paper-background-highlight1);
  transition: 0.2s all;
}

.nav-link-container.minimized.active,
.nav-link-container.minimized:hover {
  background-color: var(--color-nav-background);
}

.nav-link-container.active .nav-link-text::after {
  content: '»';
}

.nav-link-container:hover .nav-link-icon,
.nav-link-container:hover .nav-link-text {
  color: var(--color-primary);
  transition: all 0.5s;
}

.nav-link-container.minimized {
  padding: 0;
  justify-content: center;
}

.nav-link-container.minimized .nav-link-icon {
  margin-right: 0;
}

.nav-link-container.minimized .nav-link-text {
  width: 0;
}

.nav-link-icon {
  margin-right: 10px;
}

.nav-link-text {
  font-size: 16px;
  font-weight: 500;
  color: var(--color-tertiary);
  white-space: nowrap;
  /* font-family: futura; */
}

.nav-link-text.minimized {
  display: none;
}

.nav-link-badge.minimized {
  display: none;
}

.nav-link-container:hover .model-count,
.model-count.active {
  background: var(--color-almost-white);
  color: #06649a;
}

.nav-link-container a {
  text-decoration: none;
}

.model-count.minimized {
  display: none;
}

.badge-row.minimized {
  display: none;
}

.nav-link-badge {
  padding: 3px 8px;
  color: white;
  font-weight: bold;
  border-radius: 16px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-link-badge.alert {
  background-color: #ff5252;
  box-shadow: 0px 0px 7px #ff5252;
}

.separator {
  width: 100%;
  height: 1px;
  background: #eae7e7;
  margin-bottom: 10px;
}

.separator.dark {
  background: #727272;
}

.dark-mode-toggle-img {
  font-size: 12px;
  height: 24px;
  width: 24px;
  margin-bottom: -2px;
  transition: opacity 0.2s;
  color: #5b5b5b;
}

.dark-mode-toggle-img.dark {
  filter: invert(100%);
}

.dark-mode-toggle-container {
  text-align: center;
}

.dark-mode-toggle {
  width: 24px;
  height: 24px;
}

.dark-mode-toggle.dark {
  filter: invert(100%);
}

/* .nav-border-container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 100%;
}

.nav-border {
  width: 1px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background: #eae7e7;
}

.nav-border.dark {
  background: #727272;
} */

.expander {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 67px;
  left: 225px;
  width: 30px;
  height: 30px;
  background-color: var(--background-color);
  border: 0.5px solid #ebebeb;
  border-radius: 16px;
  box-shadow: 1px 2px 8px -1px rgba(0, 0, 0, 0.2);
  transition: opacity ease 0.2s, left 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
}

.expander.dark {
  background-color: var(--color-almost-white);
}

.expander.minimized {
  left: 45px;
}

.expander:hover {
  background-color: #e5f9ff;
  cursor: pointer;
}

.expander.hidden {
  opacity: 0;
}

.expander.visible {
  opacity: 1;
}

@media screen and (max-width: 959px) {
  .dashboard-nav-container {
    display: none;
  }
}
</style>
